import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import SiteDateSelector from "../SiteDateSelector";
import InsightNavigation from "../InsightNav";
import AudienceSummary from "./AudienceSummary";
import AudienceFilesDownload from "./AudienceFilesDownload";
import { getUrlParameterByName } from "../../../utils/utility";

import isUndefined from "lodash/isUndefined";
import isEmpty from "lodash/isEmpty";

class AudienceFilesIndex extends AcquireWebComponent {
  componentDidMount() {
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    if (tagId > 0 && clientId > 0) {
      this.props.getTagDetail(clientId, tagId);
      this.props.getClientSites(clientId);
      this.props.setWebsiteId(tagId);
      this.props.selectClient(clientId);
      this.props.getAudienceFilesData(tagId);
      this.props.getTagAudienceFiles(tagId);
    } else if (clientId > 0 && isEmpty(tagId)) {
      if (this.props.websiteId) {
        this.props.getTagDetail(clientId, this.props.websiteId);
        this.props.getAudienceFilesData(this.props.websiteId);
        this.props.getTagAudienceFiles(this.props.websiteId);
      }
      this.props.getClientSites(clientId);
      this.props.selectClient(clientId);
    } else {
      this.props.selectClient(this.props.selected_client);
    }
  }

  componentWillReceiveProps(nextProps) {
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    if (nextProps.selected_client !== this.props.selected_client) {
      if (
        nextProps.selected_client !== clientId &&
        nextProps.selected_client > 1
      ) {
        window.location.href =
          "/insights/audience?cid=" + nextProps.selected_client;
      }
    }
    if (nextProps.websiteId !== this.props.websiteId) {
      if (nextProps.websiteId > 0) {
        if (tagId !== nextProps.websiteId) {
          window.location.href =
            "/insights/audience?cid=" +
            clientId +
            "&tag=" +
            nextProps.websiteId;
        } else {
          this.props.getAudienceFilesData(nextProps.websiteId);
          this.props.getTagAudienceFiles(nextProps.websiteId);
        }
      }
    }
    if (isUndefined(nextProps.websiteId) && tagId > 0) {
      this.props.setWebsiteId(tagId);
    }
  }

  render() {
    const { websiteId } = this.props;
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    return (
      <div id="website-visits-container">
        <div
          style={{
            padding: "0 10%",
            marginTop: "-20px",
            marginBottom: "-10px",
            background: "#FFF",
            fontSize: "16px",
          }}
        >
          <SiteDateSelector
            key={"audience-files-site-selector-" + new Date().getTime()}
            websiteIdChanged={this.props.setWebsiteId}
            siteId={tagId ? tagId : websiteId}
            sites={this.props.client_sites}
            type={"larger"}
          />
        </div>
        <InsightNavigation
          activeIndex={5}
          clientId={this.props.selected_client}
        />
        {websiteId ? (
          <div
            className="website-visits-content bg-white"
            style={{ background: "#FFF" }}
          >
            <AudienceSummary data={this.props.audience_file_data} />
            <div style={{ height: "20px" }}>&nbsp;</div>
            <AudienceFilesDownload
              datas={this.props.audience_files}
              downloadFile={this.props.downloadTagAudienceFile}
              blobData={this.props.audience_file_blob}
            />
          </div>
        ) : (
          <div className="website-visits-content">
            <div
              style={{
                width: "100%",
                minHeight: "200px",
                textAlign: "center",
                paddingTop: "60px",
                color: "#CDCDCD",
              }}
            >
              <div
                style={{ color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" }}
              >
                No Data
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AudienceFilesIndex;



// WEBPACK FOOTER //
// ./src/components/Insights/audienceFiles/index.jsx